namespace Areas.RecordsRetention.RecordsRetention {
    import DialogResult = Areas.DialogResult;
    import sendRequest = Areas.sendRequest;
    "use strict";


    export function gotoCreate() {
        var linkInfo = "/RecordsRetention/Create/Index/";
        location.href = linkInfo;
    }

    export function selectAccount() {
        const form: any = $("#SummaryForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing);
    }

    function accountDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#SummaryForm").dxForm("instance");
        const formData: any = form.option("formData");

        formData.AccountId = data.accountId;
        formData.ProjectCCNumberName = data.projectCCNumberName;
        form.option("formData", formData);

        //per 4/9 meeting account lookup does NOT overwrite data in ProjectNumber
        //        projectDescription
        let okToUpdate = false;
        if (formData.ProjectNumber.length == 0) {
            if (formData.ProjectName.length == 0) {
                okToUpdate = true
            }
        }

        if (okToUpdate) {
            formData.ProjectNumber = data.accountNumber;
            formData.ProjectName = data.accountName;
            form.option("formData", formData);
        }

    }

    export function selectContract() {
        const form: any = $("#SummaryForm").dxForm("instance");

        const contractLookupDialog =
            new Areas.Dialogs.ContractDialog(contractDialogClosing);
    }

    function contractDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#SummaryForm").dxForm("instance");
        const formData: any = form.option("formData");

        formData.ContractId = data.contractId;
        formData.ContractName = data.contractName;

        let okToUpdate = false;
        if (formData.InspectionAcceptanceDate == null) {
            okToUpdate = true;
        }

        if (okToUpdate) {
            formData.InspectionAcceptanceDate = data.inspectionAcceptance;
            formData.NOCDate = data.nocDate;
        } else {
            const verifyOverwrite = window.confirm("Do you want to overwrite existing NOC and Inspection Dates?");

            if (verifyOverwrite) {
                formData.InspectionAcceptanceDate = data.inspectionAcceptance;
                formData.NOCDate = data.nocDate;
            }
        }


        form.option("formData", formData);

    }

    export function selectValidFund() {
        const form: any = $("#SummaryForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const validFundLookupDialog =
            new Areas.Dialogs.ValidFundLookup(validFundLookupClosing, parameters);
    }

    function validFundLookupClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#SummaryForm").dxForm("instance");
        const formData: any = form.option("formData");

        formData.AccountValidFundId = data.fundingSourceId;
        formData.FundingSourceLookupDescription = data.fundNumberName;

        //per 4/9 meeting valid fund lookup does NOT overwrite data in AccountValidFundCodeName (real field AccountValidFund)
        //        which is user editable
        let okToUpdate = false;
        if (formData.AccountValidFundCodeName.length == 0) {
            okToUpdate = true;
        }

        if (okToUpdate) {
            formData.AccountValidFundCodeName = data.FundNumberName
            form.option("formData", formData);
        }

        form.option("formData", formData);

    }

    export function selectGoverningFundSource() {
        const form: any = $("#SummaryForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const governingFundLookupDialog =
            new Areas.Dialogs.ValidFundLookup(governingFundLookupClosing, parameters);
    }

    function governingFundLookupClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const form: any = $("#SummaryForm").dxForm("instance");
        const formData: any = form.option("formData");

        formData.GoverningFundingSourceId = data.fundingSourceId;
        formData.GoverningSourceLookupDescription = data.fundNumberName;

        let okToUpdate = false;
        if (formData.GoverningFundingSource.length == 0) {
            okToUpdate = true;
        }

        if (okToUpdate) {
            formData.GoverningFundingSource = data.GoverningFundingSource
            form.option("formData", formData);
        }

        form.option("formData", formData);

    }

    export function returnToList() {
        var linkInfo = "/RecordsRetention/List/Active";
        location.href = linkInfo;

    }

    export function updateSummaryRecord() {
        const form = $("#SummaryForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/RecordsRetention/RecordsRetention/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function deleteSummaryRecord() {
        const form = $("#SummaryForm").dxForm("instance");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/RecordsRetention/RecordsRetention/Delete/${keyId}/`, "", "DELETE",
                (data) => {
                    Areas.reloadPage();
                });
        }
    }

    export function goToActions(accountId: string, contractId: string) {
        return (e: any) => {

            if (e.value == 1) {
                goToAccount(accountId);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                if (contractId != null) {
                    goToContract(contractId);
                }
                clearSelectBoxSelection(e);
                return;
            }

        }
    }




    function goToAccount(accountId: string) {
        let linkInfo = "/Account/Profile/View/" + accountId;
        window.open(linkInfo);
    }

    function goToContract(contractId: string) {
        if (contractId != null) {
            let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + contractId;
            window.open(linkInfo);
        }
    }

}